(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('changes', {
            parent: 'entity',
            url: '/changes?page&sort&search',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.changes.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/changes/changes.html',
                    controller: 'ChangesController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('changes');
                    $translatePartialLoader.addPart('status');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('changes-detail', {
            parent: 'entity',
            url: '/changes/{id}',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.changes.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/changes/changes-detail.html',
                    controller: 'ChangesDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('changes');
                    $translatePartialLoader.addPart('status');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Changes', function($stateParams, Changes) {
                    return Changes.get({id : $stateParams.id});
                }]
            }
        })
        .state('changes.new', {
            parent: 'changes',
            url: '/new',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/changes/changes-dialog.html',
                    controller: 'ChangesDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                value: null,
                                oldValue: null,
                                valueId: null,
                                oldValueId: null,
                                issuedBy: null,
                                issuedDate: null,
                                status: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('changes', null, { reload: true });
                }, function() {
                    $state.go('changes');
                });
            }]
        })
        .state('changes.edit', {
            parent: 'changes',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/changes/changes-dialog.html',
                    controller: 'ChangesDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Changes', function(Changes) {
                            return Changes.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('changes', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('changes.delete', {
            parent: 'changes',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/changes/changes-delete-dialog.html',
                    controller: 'ChangesDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Changes', function(Changes) {
                            return Changes.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('changes', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
